import { useState } from 'react';

export default function SubscribeBox() {
  const [email, setEmail] = useState('');
  const [hint, setHint] = useState('');

  const handleClick = () => {
    if (!email.trim()) {
      setHint('请先填写邮箱地址（当前为演示效果）');
      return;
    }
    setHint('已记录，本页为静态演示，不会真正发送。');
  };

  return (
    <section id="subscribe" className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="relative rounded-lg overflow-hidden bg-foreground-950 px-6 md:px-12 py-10 md:py-14">
          <div className="absolute top-0 right-0 w-40 h-40 md:w-64 md:h-64 rounded-full bg-primary-600/20 blur-3xl" />
          <div className="absolute bottom-0 left-10 w-32 h-32 md:w-48 md:h-48 rounded-full bg-accent-500/15 blur-3xl" />
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 text-[12px] font-medium text-accent-400 bg-background-50/10 border border-background-50/15 px-3 py-1 rounded-full">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-notification-3-line text-[12px]" />
                </span>
                每日追踪简报
              </span>
              <h2 className="mt-4 font-heading text-[24px] md:text-[34px] font-bold text-background-50 leading-tight">
                有新的回应或反转，第一时间推给你
              </h2>
              <p className="mt-3 text-[13px] md:text-[15px] text-background-300 max-w-[520px] leading-relaxed">
                每天午间汇总负面新闻、丑闻曝光与黑料新进展，只发有明显变化的条目，不灌水。
              </p>
            </div>
            <div className="lg:col-span-5">
              <div className="flex flex-col sm:flex-row gap-2 bg-background-50/10 border border-background-50/15 rounded-lg p-2">
                <div className="flex items-center gap-2 flex-1 px-3 py-2">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-[15px] text-background-300" />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="填写你的邮箱地址"
                    className="w-full bg-transparent text-[13px] text-background-50 placeholder:text-background-400 outline-none"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleClick}
                  className="bg-primary-600 hover:bg-primary-700 text-background-50 text-[13px] font-semibold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
                >
                  订阅追踪
                </button>
              </div>
              <p className={`mt-3 text-[12px] ${hint ? 'text-accent-400' : 'text-background-400'}`}>
                {hint || '本页为静态展示，订阅按钮仅作演示，不会提交真实数据。'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}